import type { AppAuthConfig } from '@new-cti/frontend-shared/auth/config';

// dispatch_sys アプリの認証/API 設定（共有モジュールへ注入する唯一のアプリ差分）。
// 配車ダッシュボードは常に最新を表示するため GET はブラウザキャッシュを使わない（no-store）。
export const appConfig: AppAuthConfig = {
  basePath: '/dispatch-sys',
  apiPrefix: '/api/dispatch-sys',
  getCache: 'no-store',
};
